let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iyCMz")).then(() => parcelRequire('3f4rS'));